// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import Collapse from '@/plugin/Collapse';
import App from '@/App';

Vue.config.productionTip = false;

Vue.use(Collapse);

new Vue({
    render: (h) => h(App),
}).$mount('#app');
